export const numberOr = (value, defaultValue) => (
    Number.isNaN(Number(value)) ? defaultValue : Number(value)
);

export const numberOrZero = value => (
    numberOr(value, 0)
);

export default numberOrZero;
